import { db } from "../db/database";
import type { AppUser } from "../types";
import { apiRequest } from "./api";

export async function refreshUsers(): Promise<AppUser[]> {
  const response = await apiRequest<{ users: AppUser[] }>("/users");
  await db.users.bulkPut(response.users);
  return response.users;
}

export async function createUser(input: { name: string; email: string; password: string; role: AppUser["role"]; canImport: boolean }): Promise<AppUser> {
  const response = await apiRequest<{ user: AppUser }>("/users", { method: "POST", body: JSON.stringify(input) });
  await db.users.put(response.user);
  return response.user;
}
